import { Injectable } from '@angular/core';
import { ColumnDefinitionLightModel } from '../models/column-definition-light.model';
import { ColumnDefinitionModel } from '../models/column-definition.model';
import { TableNavigationModel } from '../models/table-navigation.model';

@Injectable({
  providedIn: 'root'
})
export class PreferenceConverterHelper {

  public convertTocolumnsDefLight(columnsDefinition: ColumnDefinitionModel[]) : ColumnDefinitionLightModel[] {
    const columnsDefLight = columnsDefinition.map(function(def) {
        return new ColumnDefinitionLightModel(def.Position, def.DisplayName, def.ColumnName ,def.IsVisible, def.CanHide, def.CanSort, def.CssClass, def.IsHtmlContent, def.Pipe, def.ExportPipe, def.ToolTip);
      });

    return columnsDefLight;
  }

  public convertTocolumnsDefString(configuration: string) {
    const isNotDefLight =  configuration.includes('Position');

    if(isNotDefLight){
        return configuration;
    }

    const tableNavigation = Object.assign({}, JSON.parse(configuration)?.pageDef) as TableNavigationModel;
    const columnsDefLight: ColumnDefinitionLightModel[] = (JSON.parse(configuration)?.columnsDef) as ColumnDefinitionLightModel[];

    const columnsDef = columnsDefLight.map(function(def) {
        return new ColumnDefinitionModel(def.Pos, def.Display, def.Column ,def.IsVis, def.Hide, def.Sort, def.Css, def.IsHtml, def.Pipe, def.ExpPipe, def.ToolTip);
      });

    return JSON.stringify({ columnsDef: columnsDef, pageDef: tableNavigation });
  }
}
